import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
} from 'react'

import { twMerge } from 'tailwind-merge'

export interface TextInputProps extends React.HTMLProps<HTMLInputElement> {
  error?: string
}

export const TEXT_INPUT_STYLES = twMerge(
  'h-9 block w-full rounded-md border-0 py-2 px-3 text-primary-900 dark:text-primary-300',
  'placeholder:text-primary-400 dark:placeholder:text-primary-500',
  'ring-1 ring-inset ring-primary-200 hover:ring-primary-300 focus:ring-inset focus:ring-primary-400 text-sm leading-6',
  'bg-primary-50 dark:bg-primary-800 dark:ring-primary-700 dark:hover:ring-primary-600 dark:focus:ring-primary-600',
  'transition duration-100',
)

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ children, className, onKeyDown, ...props }, forwardedRef) => {
    const internalRef = useRef<HTMLInputElement>(null)
    useImperativeHandle(forwardedRef, () => internalRef.current!)

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
      if (onKeyDown) {
        onKeyDown(event)
      } else {
        if (event.key === 'Escape') {
          event.preventDefault()
          internalRef.current?.blur()
        }
      }
    }

    return (
      <input
        ref={internalRef}
        onKeyDown={handleKeyDown}
        {...props}
        className={twMerge(TEXT_INPUT_STYLES, className ?? '')}
      />
    )
  },
)

TextInput.displayName = 'TextInput'

export default TextInput
